// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Homepage/horizon-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Homepage/horizon-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-9 {
    margin-bottom: 10rem;
}

.section-9-top-container {
    text-align: center;

    & p:nth-child(1) {
        font-size: var(--font-size3);
        margin: 0;
    }

    & p:nth-child(2) {
        font-size: var(--font-size4);
        margin: 0;
    }

    & span {
        font-weight: bolder;
    }
}

.section-9-bottom-container {
    width: 80%;
    display: flex;
    margin: auto;
    justify-content: space-around;
    gap: 2rem;
    margin-top: 5rem;
}

.section-9-bottom-head {
    font-size: 1.875rem;
    font-weight: 500;
}

.section-9-bottom-desc {
    font-size: 1rem;
}

.section-9-bottom-left {
    width: 500px;
    border-radius: 2.5rem;
}

.section-9-bottom-left {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.section-9-bottom-left-content {
    width: 80%;
    height: max-content;
    padding-top: 1rem;
    padding-left: 2rem;
}

.section-9-bottom-right {
    width: 700px;
    height: 400px;
    border-radius: 2.5rem;
}

.section-9-bottom-right {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.section-9-bottom-right-content {
    width: 60%;
    padding-top: 1rem;
    padding-left: 2rem;
}

.section-9-button {
    margin-left: 2rem;
}

@media screen and (min-width:300px) and (max-width:490px) {
    .section-9 {
        margin-bottom: var(--margin-bottom-mobile);
    }

    .section-9-top-container {
        & p:nth-child(1) {
            font-size: var(--font-size5);
        }

        & p:nth-child(2) {
            font-size: var(--font-size7);
        }
    }

    .section-9-bottom-container {
        flex-direction: column;
        width: 100%;
        align-items: center;
        gap: 1.5rem;
    }

    .section-9-bottom-head {
        font-size: 1.5rem;
    }

    .section-9-bottom-desc {
        font-size: 0.8rem;
    }

    .section-9-bottom-left {
        width: 90%;
        height: 350px;
        border-radius: 2rem;
    }

    .section-9-bottom-left-content {
        width: 90%;
        padding-top: 0.5rem;
        padding-left: 1rem;
    }

    .section-9-bottom-right {
        width: 95%;
        height: 350px;
        border-radius: 2rem;
    }

    .section-9-bottom-right-content {
        width: 90%;
        padding-top: 0.5rem;
        padding-left: 1rem;
    }

    .section-9-button {
        margin-left: 1rem;
    }
}


@media screen and (min-width:601px) and (max-width:840px) {
    .section-9-top-container {
        & p:nth-child(1) {
            font-size: var(--font-size6);
        }

        & p:nth-child(2) {
            font-size: 1rem;
        }
    }

    .section-9-bottom-container {
        flex-direction: column;
    }

    .section-9-bottom-head {
        font-size: 1.5rem;
    }

    .section-9-bottom-desc {
        font-size: 1rem;
    }

    .section-9-bottom-left,
    .section-9-bottom-right {
        width: 90%;
        margin: auto;
        height: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section9.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB;QACI,4BAA4B;QAC5B,SAAS;IACb;;IAEA;QACI,4BAA4B;QAC5B,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yDAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,yDAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI;YACI,4BAA4B;QAChC;;QAEA;YACI,4BAA4B;QAChC;IACJ;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI;QACI;YACI,4BAA4B;QAChC;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,UAAU;QACV,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".section-9 {\r\n    margin-bottom: 10rem;\r\n}\r\n\r\n.section-9-top-container {\r\n    text-align: center;\r\n\r\n    & p:nth-child(1) {\r\n        font-size: var(--font-size3);\r\n        margin: 0;\r\n    }\r\n\r\n    & p:nth-child(2) {\r\n        font-size: var(--font-size4);\r\n        margin: 0;\r\n    }\r\n\r\n    & span {\r\n        font-weight: bolder;\r\n    }\r\n}\r\n\r\n.section-9-bottom-container {\r\n    width: 80%;\r\n    display: flex;\r\n    margin: auto;\r\n    justify-content: space-around;\r\n    gap: 2rem;\r\n    margin-top: 5rem;\r\n}\r\n\r\n.section-9-bottom-head {\r\n    font-size: 1.875rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.section-9-bottom-desc {\r\n    font-size: 1rem;\r\n}\r\n\r\n.section-9-bottom-left {\r\n    width: 500px;\r\n    border-radius: 2.5rem;\r\n}\r\n\r\n.section-9-bottom-left {\r\n    background-image: url('../../assets/Homepage/horizon-1.png');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n}\r\n\r\n.section-9-bottom-left-content {\r\n    width: 80%;\r\n    height: max-content;\r\n    padding-top: 1rem;\r\n    padding-left: 2rem;\r\n}\r\n\r\n.section-9-bottom-right {\r\n    width: 700px;\r\n    height: 400px;\r\n    border-radius: 2.5rem;\r\n}\r\n\r\n.section-9-bottom-right {\r\n    background-image: url('../../assets/Homepage/horizon-2.png');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n}\r\n\r\n.section-9-bottom-right-content {\r\n    width: 60%;\r\n    padding-top: 1rem;\r\n    padding-left: 2rem;\r\n}\r\n\r\n.section-9-button {\r\n    margin-left: 2rem;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .section-9 {\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .section-9-top-container {\r\n        & p:nth-child(1) {\r\n            font-size: var(--font-size5);\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            font-size: var(--font-size7);\r\n        }\r\n    }\r\n\r\n    .section-9-bottom-container {\r\n        flex-direction: column;\r\n        width: 100%;\r\n        align-items: center;\r\n        gap: 1.5rem;\r\n    }\r\n\r\n    .section-9-bottom-head {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .section-9-bottom-desc {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .section-9-bottom-left {\r\n        width: 90%;\r\n        height: 350px;\r\n        border-radius: 2rem;\r\n    }\r\n\r\n    .section-9-bottom-left-content {\r\n        width: 90%;\r\n        padding-top: 0.5rem;\r\n        padding-left: 1rem;\r\n    }\r\n\r\n    .section-9-bottom-right {\r\n        width: 95%;\r\n        height: 350px;\r\n        border-radius: 2rem;\r\n    }\r\n\r\n    .section-9-bottom-right-content {\r\n        width: 90%;\r\n        padding-top: 0.5rem;\r\n        padding-left: 1rem;\r\n    }\r\n\r\n    .section-9-button {\r\n        margin-left: 1rem;\r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n    .section-9-top-container {\r\n        & p:nth-child(1) {\r\n            font-size: var(--font-size6);\r\n        }\r\n\r\n        & p:nth-child(2) {\r\n            font-size: 1rem;\r\n        }\r\n    }\r\n\r\n    .section-9-bottom-container {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .section-9-bottom-head {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .section-9-bottom-desc {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .section-9-bottom-left,\r\n    .section-9-bottom-right {\r\n        width: 90%;\r\n        margin: auto;\r\n        height: 300px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
